import React, { Fragment, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { changePasswordAction, clearErrors } from '../../redux/actions/userActions';
import { CHANGE_PASSWORD_RESET } from '../../redux/constants/userConstant';
import Loader from '../loader/loader';
import { Link } from 'react-router-dom';

const ChangePassword = () => {


    const dispatch = useDispatch();

    const { loading, error, message } = useSelector(state => state.inviteUser)

    const [currentPassword, setCurrentPassword] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [showCurrentPassword, setShowCurrentPassword] = useState(false)
    const [showPassword, setShowPassword] = useState(false)
    const [showConfirmPassword, setShowConfirmPassword] = useState(false)
    const [isPasswordFocused, setIsPasswordFocused] = useState(false);




    const handleSubmit = (e) => {
        e.preventDefault();


        if (!currentPassword) {
            return toast.error("Please enter your current password");
        }

        if (!password) {
            return toast.error("Please enter your new password");
        }

        if (password.length < 8) {
            return toast.error("Password should contain at least 8 characters");
        }

        if (password !== confirmPassword) {
            return toast.error("Passwords do not match");
        }

        const passwordsObject = {
            currentPassword,
            password,
            confirmPassword,
        }
        dispatch(changePasswordAction(passwordsObject))



    }



    const getPasswordStrength = (password) => {
        let score = 0;

        if (/[a-zA-Z]/.test(password)) score++;      // any alphabet
        if (/\d/.test(password)) score++;            // number
        if (/[A-Z]/.test(password)) score++;         // uppercase
        if (/[^A-Za-z0-9]/.test(password)) score++; // special char

        return score; // 0 → 4
    };




    useEffect(() => {

        if (message) {
            toast.success(message)
            dispatch({ type: CHANGE_PASSWORD_RESET })
            setCurrentPassword("")
            setPassword("")
            setConfirmPassword("")
        }

        if (error) {
            toast.error(error)
            dispatch(clearErrors())
        }


    }, [error, message, dispatch])



    
    
        useEffect(() => {
            const Headerlinkks = document.querySelectorAll(".headerLinks")
            const element = document.getElementById("change-password")
    
            Headerlinkks.forEach(element => {
                element.classList.remove('activeHeaderLink')
            });
    
            element.classList.add('activeHeaderLink')
    
            document.title = `Change Password `;
    
        }, [])
    
    


    return (
        <Fragment>
            {loading && <Loader />}
            
            {/* Breadcrumb Header */}
            <section className='p-[1.5vmax]'>
                <div className="flex justify-between items-center bg-white p-[1vmax_2vmax] rounded-xl shadow-sm border border-gray-100">
                    <div className="flex items-center gap-3">
                        <div className="w-[0.4vmax] h-[1.8vmax] bg-indigo-600 rounded-full"></div>
                        <h2 className='text-[1.4vmax] lg:text-[1.1vmax] font-bold text-gray-800 uppercase tracking-wider'>Security Settings</h2>
                    </div>
                    <div className="flex items-center gap-3 text-[0.9vmax] font-medium">
                        <Link to={'/profile'} className="text-gray-500 hover:text-indigo-600 transition-colors">Profile</Link>
                        <i className="fa-solid fa-chevron-right text-gray-300 text-[0.7vmax]"></i>
                        <span className='text-indigo-600'>Change Password</span>
                    </div>
                </div>
            </section>

            <section className="w-full flex justify-center p-[2vmax_1.5vmax]">
                <div className="bg-white rounded-2xl p-[3.5vmax] w-full max-w-[450px] shadow-xl border border-gray-100 relative overflow-hidden group">
                    {/* Decorative Elements */}
                    <div className="absolute top-0 right-0 w-32 h-32 bg-indigo-50 rounded-full blur-3xl -mr-16 -mt-16 group-hover:bg-indigo-100 transition-colors"></div>
                    
                    <div className="relative z-10">
                        <form className="flex flex-col items-center w-full" onSubmit={handleSubmit}>
                            {/* Icon Header */}
                            <div className="w-[4.5vmax] h-[4.5vmax] rounded-2xl bg-gradient-to-br from-indigo-500 to-blue-600 flex-center shadow-lg shadow-indigo-100 mb-[1.5vmax]">
                                <i className="fa-solid fa-shield-halved text-[2.2vmax] text-white"></i>
                            </div>
                            
                            <h4 className='text-[2.2vmax] lg:text-[1.8vmax] font-bold text-gray-800 text-center mb-1'>Update Password</h4>
                            <p className='text-[0.95vmax] text-gray-500 text-center mb-[2.5vmax] px-4 leading-relaxed'>
                                Secure your account by creating a strong, unique password.
                            </p>

                            <div className="w-full space-y-[1.8vmax]">
                                {/* Current Password */}
                                <div className='flex flex-col gap-1.5'>
                                    <label className='text-[0.85vmax] font-bold text-gray-600 ml-1'>Current Password <span className='text-red-500'>*</span></label>
                                    <div className="relative group">
                                        <i className="fa-solid fa-lock-open absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 group-focus-within:text-indigo-600 transition-colors"></i>
                                        <input
                                            type={showCurrentPassword ? 'text' : 'password'}
                                            value={currentPassword}
                                            onChange={(e) => setCurrentPassword(e.target.value.replace(/\s/g, ""))}
                                            className='w-full bg-gray-50 pl-12 pr-12 py-3.5 rounded-xl border border-gray-200 outline-none focus:bg-white focus:border-indigo-500 focus:ring-4 focus:ring-indigo-50 transition-all text-[0.95vmax] font-medium text-gray-700'
                                            placeholder='Enter Current Password'
                                        />
                                        <button 
                                            type='button'
                                            className='absolute right-4 top-1/2 -translate-y-1/2 text-gray-400 hover:text-indigo-600 transition-colors p-1'
                                            onClick={() => setShowCurrentPassword(!showCurrentPassword)}
                                        >
                                            <i className={`fa-solid ${showCurrentPassword ? 'fa-eye-slash' : 'fa-eye'}`}></i>
                                        </button>
                                    </div>
                                </div>

                                {/* New Password */}
                                <div className='flex flex-col gap-1.5'>
                                    <label className='text-[0.85vmax] font-bold text-gray-600 ml-1'>New Strong Password <span className='text-red-500'>*</span></label>
                                    <div className="relative group">
                                        <i className="fa-solid fa-key absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 group-focus-within:text-indigo-600 transition-colors"></i>
                                        <input
                                            type={showPassword ? 'text' : 'password'}
                                            value={password}
                                            onChange={(e) => setPassword(e.target.value.replace(/\s/g, ""))}
                                            onFocus={() => setIsPasswordFocused(true)}
                                            onBlur={() => setIsPasswordFocused(false)}
                                            className='w-full bg-gray-50 pl-12 pr-12 py-3.5 rounded-xl border border-gray-200 outline-none focus:bg-white focus:border-indigo-500 focus:ring-4 focus:ring-indigo-50 transition-all text-[0.95vmax] font-medium text-gray-700'
                                            placeholder='Enter Strong Password'
                                        />
                                        <button 
                                            type='button'
                                            className='absolute right-4 top-1/2 -translate-y-1/2 text-gray-400 hover:text-indigo-600 transition-colors p-1'
                                            onClick={() => setShowPassword(!showPassword)}
                                        >
                                            <i className={`fa-solid ${showPassword ? 'fa-eye-slash' : 'fa-eye'}`}></i>
                                        </button>
                                    </div>

                                    {/* Password Strength Indicator */}
                                    <div className={`mt-2 overflow-hidden transition-all duration-300 ${isPasswordFocused || password ? 'max-h-10 opacity-100' : 'max-h-0 opacity-0'}`}>
                                        <div className="flex items-center gap-1">
                                            {[1, 2, 3, 4].map((level) => {
                                                const strength = getPasswordStrength(password);
                                                let bg = "bg-gray-200";
                                                if (strength >= level) {
                                                    if (strength === 1) bg = "bg-red-400";
                                                    if (strength === 2) bg = "bg-amber-400";
                                                    if (strength === 3) bg = "bg-indigo-400";
                                                    if (strength === 4) bg = "bg-green-500";
                                                }
                                                return <div key={level} className={`h-1.5 flex-1 rounded-full ${bg} transition-colors duration-500`}></div>;
                                            })}
                                        </div>
                                        <p className="text-[0.75vmax] text-gray-400 mt-1 font-bold uppercase tracking-wider">
                                            {password ? (getPasswordStrength(password) < 3 ? 'Weak Password' : getPasswordStrength(password) === 3 ? 'Good Password' : 'Very Strong!') : 'Password Strength'}
                                        </p>
                                    </div>
                                </div>

                                {/* Confirm Password */}
                                <div className='flex flex-col gap-1.5'>
                                    <label className='text-[0.85vmax] font-bold text-gray-600 ml-1'>Confirm New Password <span className='text-red-500'>*</span></label>
                                    <div className="relative group">
                                        <i className="fa-solid fa-check-double absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 group-focus-within:text-indigo-600 transition-colors"></i>
                                        <input
                                            type={showConfirmPassword ? 'text' : 'password'}
                                            value={confirmPassword}
                                            onChange={(e) => setConfirmPassword(e.target.value.replace(/\s/g, ""))}
                                            className='w-full bg-gray-50 pl-12 pr-12 py-3.5 rounded-xl border border-gray-200 outline-none focus:bg-white focus:border-indigo-500 focus:ring-4 focus:ring-indigo-50 transition-all text-[0.95vmax] font-medium text-gray-700'
                                            placeholder='Re-enter New Password'
                                        />
                                        <button 
                                            type='button'
                                            className='absolute right-4 top-1/2 -translate-y-1/2 text-gray-400 hover:text-indigo-600 transition-colors p-1'
                                            onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                        >
                                            <i className={`fa-solid ${showConfirmPassword ? 'fa-eye-slash' : 'fa-eye'}`}></i>
                                        </button>
                                    </div>
                                    {password && confirmPassword && password !== confirmPassword &&
                                        <p className='text-red-500 text-[0.8vmax] mt-1 font-bold flex items-center gap-1 animate-pulse' >
                                            <i className="fa-solid fa-circle-exclamation"></i>
                                            Passwords do not match
                                        </p>
                                    }
                                </div>
                            </div>

                            <button
                                type='submit'
                                className={`w-full bg-gradient-to-r from-indigo-600 to-blue-600 text-white rounded-xl py-4 mt-[2.5vmax] font-bold text-[1.1vmax] flex items-center justify-center gap-3 shadow-lg shadow-indigo-100 hover:shadow-indigo-200 transition-all hover:scale-[1.02] active:scale-[0.98] disabled:opacity-50 disabled:grayscale disabled:scale-100 disabled:shadow-none disabled:cursor-not-allowed`}
                                disabled={currentPassword === '' || password === '' || confirmPassword === '' || getPasswordStrength(password) < 3}
                            >
                                <i className="fa-solid fa-circle-check"></i>
                                Update Password
                            </button>
                        </form>
                    </div>
                </div>
            </section>
            <div className="h-[5vmax]"></div>
        </Fragment>
    )
}

export default ChangePassword